export const baseURL = "https://api.qtradeview.com" // development/staging
// 
// export const baseURL = "https://localhost:7261";
export const secureEndPoint = "api/secure";
export const publicEndpoint = "api/public";
export const generalEndpoint = "api";
